import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoriesSection from './components/CategoriesSection';
import ArticleGridSection from './components/ArticleGridSection';
import TrustSection from './components/TrustSection';
import FAQSection from './components/FAQSection';
import FinalCTASection from './components/FinalCTASection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://itaobuyspread.beauty';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoriesSection />
        <ArticleGridSection />
        <TrustSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Itaobuy Spreadsheet Italia',
            url: siteUrl,
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/62f99c0415358bd5388d5ed1df9ac1ff.jpeg',
            description: 'Portale italiano dedicato a Itaobuy Spreadsheet: guide complete, prodotti verificati, QC foto e consigli per acquisti sicuri.',
            sameAs: [
              'https://kaspreadsheet.com',
            ],
          }),
        }}
      />
    </>
  );
}